<template>
  <VisitDwellTotal
    v-if="area?.name === 'Zone' && time?.name === 'Total'"
    :zone="zone"
    :widget="widget"
  />

  <VisitDwellDaily
    v-if="area?.name === 'Zone' && time?.name === 'Day'"
    :zone="zone"
    :widget="widget"
  />

  <VisitDwellAverage
    v-if="area?.name === 'Zone Average'"
    :time="time"
    :zone="zone"
    :widget="widget"
    :day="day"
  />
</template>

<script setup lang="ts">
import VisitDwellTotal from './VisitDwellTotal.vue';

import type { WidgetFilter, WidgetSetting, WidgetTypeEngagedVisitDwell } from '@/types/Widget';
import VisitDwellDaily from './VisitDwellDaily.vue';
import VisitDwellAverage from './VisitDwellAverage.vue';

defineProps<{
  widget: WidgetTypeEngagedVisitDwell;
  area?: WidgetFilter;
  time?: WidgetFilter;
  zone?: WidgetSetting;
  day?: WidgetSetting;
}>();
</script>

<style lang="scss">
.widget .dwell-average {
  @include mixins.flex-center($horiz: flex-start, $gap: variables.$sizing-xxs);

  .dwell-time__icon {
    background: variables.$primitives-color-border-100;
    margin: 0;
  }

  .widget__label {
    padding: 0;
  }

  .widget__bignumber {
    flex-shrink: 0;
    font-size: 32px;
    font-weight: bold;
    margin-left: variables.$sizing-xs;
  }
}
</style>
